
import { ArrowDown } from 'lucide-react';
import BackgroundElements from './BackgroundElements';
import HeroContent from './HeroContent';
import PhoneMockup from './PhoneMockup';

const HeroSectionV4 = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden px-4">
      {/* Background Elements with subtle bubbles */}
      <BackgroundElements />

      <div className="container max-w-7xl mx-auto grid lg:grid-cols-2 gap-12 items-center relative z-10">
        {/* Left Content */}
        <HeroContent />

        {/* Right Content - Realistic iPhone Mockup */}
        <PhoneMockup />
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <ArrowDown className="w-6 h-6 text-white/60" />
      </div>
    </section>
  );
};

export default HeroSectionV4;
